import { createBrowserRouter } from 'react-router-dom';
import NotFound from '../Pages/NotFound/NotFound';
import Layoutm from '../LayoutTwo/Layout';
// import {Dashboard, About,Services ,ServicesDetails,Portfolio,AllPortfolioDetails,Blog,
//   AllBlogDetails,Contactus,MentoringServices,SalesServices,Branding,Faqs

// } from '../Pages/Exports';
import LinkedinBlogDetails from '../Pages/Blog/BlogDetails/LinkedinBlogDetails';
import Dashboard from '../Pages/Dashboard';
import About from '../Pages/About';
import Services from '../Pages/Services';
import MentoringServices from '../Pages/Services/ServicesDetails/MentoringService';
import SalesServices from '../Pages/Services/ServicesDetails/SalesServices';
import Portfolio from '../Pages/Portfolio';
import AllPortfolioDetails from '../Pages/Portfolio/PortfolioDetails/AllPortfolioDetails';
import Blog from '../Pages/Blog';
import AllBlogDetails from '../Pages/Blog/BlogDetails/AllBlogDetails';
import Contactus from '../Pages/Contactus';
import Faqs from '../Pages/Faqs';
import ProjectDetails from '../Pages/Services/ServicesDetails/SalesServices/ProjectDetails';
import SimpleProjectLanding from '../Pages/Services/ServicesDetails/SalesServices/SimpleProjectLanding';
import Nri from '../Pages/Nri';
import TermsandConditions from '../Pages/TermsandConditions';
import RefundPolicy from '../Pages/RefundPolicy';
import PrivacyPolicy from '../Pages/PrivacyPolicy/PrivacyPolicy';
import Payment from '../Pages/Payment';
import LandingPage from '../Pages/LandingPage';
import OnBoardingForm from '../Pages/OnBoardingForm/OnBoardingForm';
import LatestCoaching from '../Pages/Services/ServicesDetails/LatestCoaching';
import Webinar from '../Pages/Webinar';
import Resume from '../Pages/Resume';
import LeadGen from '../Pages/LeadGen';
import { Man } from '@mui/icons-material';
import Mandate from '../Pages/Mandate';
import NewDashboard from '../Pages/NewDashboard';
import Careers from '../Pages/Careers';
import TribhujaDegitalForm from '../Pages/TribhujaDegitalForm';

const router = createBrowserRouter([
  {
    element: <Layoutm />,
    children: [
      {
        path: '/',
        element: <Dashboard />,
      },
      {
        path: '/about-us',
        element: <About />,
      },
      {
        path: '/services',
        element: <Services />,
      },
      // {
      //   path:"/services/:id",
      //   element:<ServicesDetails/>

      // },
      {
        path: '/services/luxury-sales-coaching',
        element: <MentoringServices />,
      },
       {
        path: '/services/luxury-sales-coach',
        element: <LatestCoaching />,
      },
      // {
      //   path: '/services/luxury-sales-consulting',
      //   element: <SalesServices />,
      // },
       {
        path: '/services/luxury-sales-consulting',
        element: <Mandate />,
      },
       {
    path: '/services/realty',
    element: <SalesServices/>,
  },
      {
        path: '/portfolio',
        element: <Portfolio />,
      },
      {
        path: '/portfolio/:id',
        element: <AllPortfolioDetails />,
      },
      {
        path: '/blogs',
        element: <Blog />,
      },
      {
        path: '/blog/:id',
        element: <AllBlogDetails />,
      },
      {
        path: '/contactus',
        element: <Contactus />,
      },
      {
        path: '/faqs',
        element: <Faqs />,
      },
      {
        path: '/blogs/:slug',
        element: <LinkedinBlogDetails />,
      },
      {
        path: '/nri',
        element: <Nri />,
      },
      {
        path: '/terms-and-conditions',
        element: <TermsandConditions />,
      },
      {
        path: '/refund-policy',
        element: <RefundPolicy />,
      },
      {
        path: '/privacy-policy',
        element: <PrivacyPolicy />,
      },
      {
        path: '/mentoring/payment/:id',
        element: <Payment />,
      },
      {
        path: '/fast-track-sales-workshop',
        element: <LandingPage />,
      },
      {
    path: '/homee',
    element: <NewDashboard/>,
  },
  {
    path: '/careers',
    element: <Careers/>,
  },
  //  {
  //   path: '/services/mandate',
  //   element: <Mandate/>,
  // }
    ],
  },
  {
    path: '*', // Catch-all route for 404 Not Found
    element: <NotFound />,
  },
  {
    path: '/projects/:slug',
    element: <ProjectDetails />,
  },
  {
    path: '/projects/:slug',
    element: <ProjectDetails />,
  },
  {
    path: '/onboardingform',
    element: <OnBoardingForm />,
  },
    {
    path: '/webinar-landing',
    element: <Webinar/>,
  },
  {
    path: '/executive-profile',
    element: <Resume/>,
  },
  {
    path: '/luxury-sales-coach&consultant',
    element: <LeadGen/>,
  },

  {
    path: '/tribuja-digital-form',
    element: <TribhujaDegitalForm/>,
  },

 
]);

export default router;
